import { WfpHumEmergencyResponsePos } from '@wfp/pictograms-react';
import { Link, Story, Text, Wrapper } from '@wfp/react';
import React, { FC } from 'react';

const NotFound: FC = () => {
  return (
    <Wrapper pageWidth="lg" spacing="md">
      <Story className="wfp--story__center wfp--story__full-height">
        <WfpHumEmergencyResponsePos
          color="#007DBC"
          width="200px"
          height="200px"
          style={{ marginBottom: '3rem', transform: 'rotate(10deg)' }}
        />
        <Text kind="h1" className="wfp--story__title">
          Sorry, we couldn&apos;t find that page
        </Text>
        <Text>
          Go back to the <Link href="/">Homepage</Link>
        </Text>
      </Story>
    </Wrapper>
  );
};

export default NotFound;
